import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
  sign_key?: string;
  aes_key?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#00B6ED',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '',
  pwa: true,
  logo: '/logo.png',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
  sign_key: '0f23de9139bdf529f703ae9bb466f265',
  aes_key: 'qw5w6SFE2D1jmxyd',
};

export default Settings;
